"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MultiTab = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _multiTab = require("./multiTab.style");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MultiTab = function MultiTab(props) {
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _multiTab.useStyles)(props);
  var titleE = (0, _react.useRef)(null);
  var contentE = (0, _react.useRef)(null);

  var selectItem = function selectItem(value) {
    for (var i = 0; i < titleE.current.children.length; i++) {
      if (titleE.current.children[i].children[1].classList.contains(classes.active)) {
        titleE.current.children[i].children[1].classList.remove(classes.active);
        contentE.current.children[i].classList.remove(classes.dBlock);
      }
    }

    document.getElementById("title-".concat(value)).classList.add(classes.active);
    document.getElementById("content-".concat(value)).classList.add(classes.dBlock);
  };

  var headers = props.value.headers.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.title),
      onClick: function onClick() {
        return selectItem(item.contentName);
      },
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.titleText)
    }, item.name), /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(index === 0 && classes.active),
      id: "title-".concat(item.contentName)
    }));
  });
  var contents = props.value.contents.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.content, " ").concat(index === 0 && classes.dBlock),
      id: "content-".concat(item.name),
      key: index
    }, item.content);
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.tableBox
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.head),
    ref: titleE
  }, headers), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.line)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    ref: contentE
  }, contents));
};

exports.MultiTab = MultiTab;
var _default = MultiTab;
exports["default"] = _default;